// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeSelect{
    width:50%;
    padding:10px
}

.dropLevelArea {
    background-color: lightgray;
    margin :10px;
}
.margin10{
    margin:10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/objectcreator/measuredefinition/panels/dynamictimereference/dynamictimereference.control.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,WAAW;AACf","sourcesContent":[".timeSelect{\n    width:50%;\n    padding:10px\n}\n\n.dropLevelArea {\n    background-color: lightgray;\n    margin :10px;\n}\n.margin10{\n    margin:10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
